import styled, { from } from 'theme';

import { PageWrapper } from '../Dashboard.styles';

export const AdminToolsWrapper = styled(PageWrapper)`
  .admin_tools__column {
    margin-bottom: 2rem;
  }

  ${from('xlg')} {
    .admin_tools__column:nth-child(odd) {
      .admin_tool {
        margin-right: 1rem;
      }
    }

    .admin_tools__column:nth-child(even) {
      .admin_tool {
        margin-left: 1rem;
      }
    }
  }
`;
